import React, { useEffect, useState } from 'react'

interface NotificationPopupProps {
  title: string
  body: string
  id: string
  isIssue: boolean
  onClose: (id: string) => void
}

const DriverManifestsNotificationPopup: React.FC<NotificationPopupProps> = ({ title, body, id, isIssue, onClose }) => {
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setExiting(true)
    }, 1800)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (exiting) {
      const exitTimer = setTimeout(() => {
        onClose(id)
      }, 400)
      return () => clearTimeout(exitTimer)
    }
    return undefined
  }, [exiting, id, onClose])

  return (
    <div
      className={
        `dm-notification-popup ${exiting ? 'exit' : ''} ` +
        (isIssue ? (body.includes('Late') ? 'dm-late' : 'dm-issue') : '')
      }
    >
      <div className={`dm-popup-content ` + (isIssue ? (body.includes('Late') ? 'dm-late' : 'dm-issue') : '')}>
        <div className='dm-popup-header'>
          <strong>{title}</strong>
        </div>
        <div className='dm-popup-body'>{body}</div>
        <button className='dm-close-button' onClick={() => setExiting(true)}>
          X
        </button>
      </div>
    </div>
  )
}

export default DriverManifestsNotificationPopup



// WEBPACK FOOTER //
// ./src/components/driver-manifests/DriverManifestsNotificationPopup.tsx